import { type Context, createContext } from 'react';

/**
 * Marks the subtree rendered by `NBMRendererHydrationBridge`, i.e. content that came from recursive
 * LCM SSR and is mid-handoff to the manifests.
 *
 * A nested LCM that reaches its manifest inside such a subtree should inherit the ambient provider
 * factory's manifests rather than building and populating a factory of its own — it is already
 * inside a renderer that has them. Outside a bridged subtree (a client-only page, an SPA
 * transition, the editor) there is nothing to inherit and the LCM keeps its own factory, scoped to
 * its own content.
 *
 * This is deliberately a context rather than a feature-gate value: what matters is the situation the
 * LCM is being rendered in, not whether recursive SSR is enabled somewhere on the page.
 */
export const NestedLcmHierarchyContext: Context<boolean> = createContext<boolean>(false);
